import TemplateBase from '../template-base';

/**
 * The JS controller for page templates.
 */
class Page extends TemplateBase {

    bodyClass = 'page';

    docReady() {
        console.log('Hey, we are on a page!');
    }

}

// Export the singleton.
export default new Page();
